export default __webpack_public_path__ + "static/media/IMG_4584-min.1be14b68.JPG";